import { put, select, takeLatest } from "redux-saga/effects";
import { LOAD_ABSENCE, CHANGE_ABSENCE, DELETE_ABSENCE } from "./constants";

import {
  loadAbsenceError,
  loadAbsenceSuccess,
  changeAbsenceError,
  changeAbsenceSuccess,
  deleteAbsenceSuccess,
  deleteAbsenceError,
} from "./actions";

import { notification } from "antd";

// utils
import requestWrapper from "utils/requestWrapper";
import history from "utils/history";

import api from "utils/api";
const { endpoint } = api;
import { getObjId } from "utils/helpers/helper.general";
import _local from "utils/localStorageUtils";

export function* loadAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { id } = action;

    // we get the campaigns linked to the absence
    const absenceData = yield requestWrapper(
      "GET",
      endpoint?.absences?.single(id),
      "",
      currentUser.token,
    );

    if (!absenceData) {
      yield put(loadAbsenceSuccess(false));
    } else {
      yield put(loadAbsenceSuccess(absenceData));
    }
  } catch (error) {
    yield put(loadAbsenceError(error));
  }
}

export function* changeAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { absenceData } = action;
    let changedAbsence = false,
      isNew = !absenceData?._id;

    if (!!isNew) {
      changedAbsence = yield requestWrapper(
        "POST",
        endpoint?.absences?.new,
        absenceData,
        currentUser.token,
      );
    } else {
      changedAbsence = yield requestWrapper(
        "PATCH",
        endpoint?.absences?.update,
        absenceData,
        currentUser.token,
      );
    }
    if (!changedAbsence) {
      yield put(changeAbsenceSuccess(false));
    } else {
      // if new we update the url, item props will be updated
      if (!!isNew) {
        notification.success({ message: "Enregistrement avec succès" });
        history.push({ pathname: `/absences/${changedAbsence?._id}` });
      } else {
        notification.success({ message: "L'absence a été modifiée" });
      }

      yield put(changeAbsenceSuccess(changedAbsence));
    }
  } catch (error) {
    yield put(changeAbsenceError(error));
  }
}

export function* deleteAbsence(action) {
  try {
    // we retrieve the token from the local storage
    const currentUser = yield _local.getLocalUser();
    const { role } = currentUser;
    const { id } = action;

    const deleteAbsence = yield requestWrapper(
      "PATCH",
      endpoint?.absences?.archive,
      {
        _id: id,
      },
      currentUser.token,
    );

    if (deleteAbsence) {
      yield put(deleteAbsenceSuccess());
    }
  } catch (error) {
    yield put(deleteAbsenceError(error));
  }
}

export default function* absenceSaga() {
  yield takeLatest(LOAD_ABSENCE, loadAbsence);
  yield takeLatest(CHANGE_ABSENCE, changeAbsence);
  yield takeLatest(DELETE_ABSENCE, deleteAbsence);
}
